export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(Number(n || 0));

export const MONTHS_IT = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export const MONTHS_SHORT_IT = ["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"];

export const formatPeriod = (period) => {
  // period like "2025-03"
  if (!period) return "";
  const [y, m] = period.split("-").map(Number);
  return `${MONTHS_SHORT_IT[m - 1]} ${String(y).slice(2)}`;
};

export const personColor = (p) => (p === "Madda" ? "#D26A50" : "#4A6D5E");

export const formatDateIt = (d) => {
  if (!d) return "";
  const [y, m, day] = d.split("-");
  return `${day}/${m}/${y}`;
};
